<template>
    <nav class="navbar" :class="{'is-fixed': navBarTop }" role="navigation" aria-label="main navigation" ref="navbar">
      <div class="navbar-brand">
        <a href="/" class="navbar-item"><img src="../assets/logo.png"></a>
        <a role="button" class="navbar-burger"
          @click="isOpen = !isOpen"
          :class="{'is-active': isOpen}"
          aria-label="menu" aria-expanded="false">
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>
      <div class="navbar-menu" :class="{'is-active': isOpen }" @click="isOpen = false">
        <router-link to="/" class="navbar-item" active-class="is-active" exact><font-awesome-icon icon="home"></font-awesome-icon>Home</router-link>
        <router-link to="/timeline" class="navbar-item" active-class="is-active"><font-awesome-icon icon="hourglass-half"></font-awesome-icon>Timeline</router-link>
        <router-link to="/photos" class="navbar-item" active-class="is-active"><font-awesome-icon icon="images"></font-awesome-icon>Photos</router-link>
        <router-link to="/videos" class="navbar-item" active-class="is-active"><font-awesome-icon icon="video"></font-awesome-icon>Video</router-link>
        <router-link to="/interactive" class="navbar-item" active-class="is-active"><font-awesome-icon icon="eye"></font-awesome-icon>Interactive</router-link>
        <!-- <router-link to="#" class="navbar-item" active-class="is-active"><font-awesome-icon icon="map-marked-alt"></font-awesome-icon>Location</router-link> -->
      </div>
    </nav>
</template>

<script>
export default {
  data: () => {
    return {
      isOpen: false,
      navBarYpos: 0,
      navBarTop: false
    }
  },
  methods: {
    handleScroll: function (event) {
      if (window.pageYOffset >= this.navBarYpos) {
        this.navBarTop = true
      } else {
        this.navBarTop = false
      }
    }
  },
  mounted: function () {
    this.navBarYpos = this.$refs.navbar.offsetTop
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed: function () {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
